export const bookingCharges = {
  header: {
    title: "Addebiti",
    titleNew: "Nuovi addebiti",
    sub: "Voci da includere nella fattura dell’ospite.",
    subNew:
      "Per la prossima fattura. L’alloggio già fatturato è mostrato sopra, nella sua fattura.",
  },
  loading: "Caricamento addebiti…",
  empty: {
    title: "Nessun addebito registrato",
    titleBilled: "Nessun addebito in sospeso",
    sub: "Aggiungi alloggio, pulizie, extra o altri servizi.",
    subBilled: "Aggiungi un addebito per creare un’altra fattura per questa prenotazione.",
  },
  buttons: {
    addCharge: "Aggiungi addebito",
    addFirstCharge: "Aggiungi il primo addebito",
    manage: "Gestisci",
    manageTemplatesTitle: "Gestisci modelli",
    add: "Aggiungi",
    close: "Chiudi",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveCharge: "Salva addebito",
    saveChanges: "Salva modifiche",
    deleting: "Eliminazione…",
    confirmDelete: "Sì, elimina",
    editTitle: "Modifica",
    deleteTitle: "Elimina",
  },
  table: {
    item: "Voce",
    qty: "Qtà",
    unitPrice: "Prezzo unitario",
    vat: "IVA",
    total: "Totale",
  },
  chips: {
    lodging: "Alloggio",
    discount: "Sconto",
    autoSynced: "Sincronizzato automaticamente",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 notte | {n} notti",
    rooms: "1 camera | {n} camere",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Camera",
    roomAll: "Tutta la prenotazione",
    roomHint: "Se è di una camera, finirà nella fattura di quella camera.",
    date: "Data",
    category: "Categoria",
    quantity: "Quantità",
    unitPriceFull: "Prezzo unitario",
    vatPct: "IVA (%)",
    name: "Nome",
    price: "Prezzo",
    internalNotes: "Note interne",
    paymentMethod: "Metodo di pagamento",
    paymentDate: "Data di pagamento",
    guestCount: "Numero di ospiti",
  },
  placeholders: {
    item: "Seleziona o digita una voce…",
    egCleaning: "es. Pulizie",
    internalNote: "Aggiungi nota interna…",
  },
  templates: {
    savedTitle: "Addebiti salvati",
    noResults: 'Nessun risultato per "{query}"',
    emptyPre: "Nessun addebito salvato. ",
    createOne: "Creane uno",
    manageTitle: "Addebiti personalizzati",
    manageSub: "Crea addebiti riutilizzabili per le tue fatture.",
    emptyList: "Nessun addebito salvato. Aggiungi il primo qui sopra.",
    noCategory: "Nessuna categoria",
  },
  vat: {
    labelPct: "IVA {rate}%",
  },
  modal: {
    editTitle: "Modifica addebito",
    addSub: "Nuova voce per la fattura",
    editSub: "Modifica i dettagli dell’addebito",
    totalCalculated: "Totale calcolato",
  },
  common: {
    optional: "(opzionale)",
    unspecified: "Non specificato",
  },
  invoice: {
    sectionLabel: "Fattura elettronica",
  },
  footer: {
    pending: "In attesa di fatturazione",
    totalDue: "Totale dovuto",
  },
  deleteModal: {
    title: "Eliminare l’addebito?",
    sub: "Questa azione non può essere annullata.",
  },
  autoCategory: {
    service: "Servizio",
    fee: "Commissione",
    extraGuest: "Ospite extra",
    tax: "Tassa",
    cityTax: "Tassa di soggiorno",
    adjustment: "Adeguamento",
    autoFallback: "Addebito automatico",
  },
  chargeBasis: {
    percentOfTotal: "Percentuale del totale",
    perNight: "Per notte",
    perPerson: "Per persona",
    perPersonPerNight: "Per persona a notte",
    perStay: "Per prenotazione",
  },
  toast: {
    descRequired: "La descrizione è obbligatoria.",
    chargeAdded: "Addebito aggiunto.",
    chargeUpdated: "Addebito aggiornato.",
    chargeDeleted: "Addebito eliminato.",
    chargeSaved: "Addebito salvato.",
    saveFailed: "Impossibile salvare.",
    deleteFailed: "Impossibile eliminare.",
    warningTitle: "Attenzione",
    doneTitle: "Fatto",
    errorTitle: "Errore",
  },
  invoices: {
    title: "Fatture emesse",
    noName: "Senza nome",
    conceptCount: "{count} voce | {count} voci",
    viewPdf: "Visualizza PDF",
    sendWhatsapp: "Invia tramite WhatsApp",
    correct: "Correggi (rettificativa)",
    void: "Annulla (fattura rettificativa)",
    conceptsFoot:
      "Queste voci sono già fatturate. Il PDF contiene il dettaglio completo.",
  },
  status: {
    draft: "Bozza",
    sent: "Emessa",
    processing: "In elaborazione",
    pending: "In sospeso",
    error: "Errore",
    corrected: "Rettificata",
    voided: "Annullata",
  },
  checkinModal: {
    title: "Dettagli della registrazione",
    bookingLink: "Prenotazione #{code}",
    requestDate: "Data della richiesta: {date} alle {time}",
  },
  payment: {
    desti: "Paga in struttura",
    efect: "Contanti",
    movil: "Pagamento mobile",
    otro: "Altri metodi di pagamento",
    platf: "Piattaforma di pagamento",
    tarjt: "Carta di credito",
    trans: "Bonifico bancario",
    treg: "Carta regalo",
  },
};
